class ShopiPromos {
    constructor(store) {
        this._store = store
        this.initialCart = null;
    }

    getPromos() {
        fetch(`https://nestle-pe-shopipromos.appsinnovategroup.com/promos?store=${this._store}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        }).then(response => response.text())
            .then(result => {

                if (window) {
                    if (window.$Cart === undefined) {
                        
                    } else {
                        this.promoValidator(JSON.parse(result))
                    }
                }
            })
            .catch(error => console.log('error', error))
    }

    async promoValidator(promos) {
        const today = new Date().getTime()
        const currentCart = $Cart.state.info;

        if(!!!currentCart) return;

        const insertAfter = function (tag, classString, template, target) {
            const newNode = document.createElement(tag)
            newNode.classList.add(classString)
            newNode.innerHTML = template
            if (target) {
                target.parentNode.insertBefore(newNode, target.nextSibling)
            }
        }

        promos.forEach(promo => {
            if (promo && promo.status == 1) {
                let promoDataObj = {}


                let promoDateConditional = true
                if (promo.data.includes('{')) {
                    promoDataObj = JSON.parse(promo.data)

                    if (promoDataObj && promoDataObj.enableAutoEnable == false) {
                        promoDateConditional = false
                    }
                }

                if (
                    (today <= promo.active_date_to && today >= promo.active_date_from) ||
                    promoDateConditional === false
                ) {
                    const data = JSON.parse(promo.data)

                    if (promo && promo.type == 'gift_product_by_items') {
                        const productsIf = data['ifAddThis']
                        const productsToAdd = data['doIt']['products']
                        let variantsIdCurrentCart = currentCart.items.map(a => a.variant_id)
                        let variantsIdProductsIf = productsIf.map(b => b.variantID)
                        let variantsIdProductsToAdd = productsToAdd.map(c => c.variantID)
                        let hasPromo = variantsIdProductsIf.every(function (val) { return variantsIdCurrentCart.indexOf(val) >= 0 })

                        if (hasPromo) {
                            const list = []

                            productsToAdd.forEach(prod => {
                                if (!variantsIdCurrentCart.includes(prod.variantID)) {
                                    list.push({
                                        id: prod.variantID,
                                        quantity: 1,
                                        properties: {
                                            "itsFree": "true"
                                        }
                                    })
                                }
                            })

                            if (list[0]) $Cart.addItem(list, false)

                        } else {
                            productsToAdd.forEach(prod => {
                                if (variantsIdCurrentCart.includes(prod.variantID)) {

                                    $Cart.removeItem(prod.variantID)
                                }
                            })
                        }

                        currentCart.items.forEach(cartItem => {
                            if (cartItem.price == 0 && variantsIdCurrentCart.includes(cartItem.variant_id) && !variantsIdProductsToAdd.includes(cartItem.variant_id)) {
                                $Cart.removeItem(cartItem.variant_id)
                            }
                        })
                    }

                    if (promo && promo.type == 'gift_product_by_items_from_colections') {

                        const productsIf = data['ifAddThis']
                        const productsToAdd = data['doIt']['products']

                        let variantsIdCurrentCart = currentCart.items.map(a => a.variant_id)
                        let variantsIdProductsIf = productsIf.map(b => b.variantID)
                        let variantsIdProductsToAdd = productsToAdd.map(c => c.variantID)

                        let hasPromo = false

                        if (promoDataObj.numberCollection === 0) {
                            hasPromo = variantsIdProductsIf.every(function (val) { return variantsIdCurrentCart.indexOf(val) >= 0 })
                        } else {

                            let pusher = []
                            let totalQty = 0

                            for (var i = 0; i < currentCart.items.length; i++) {
                                const cartItem = currentCart.items[i]
                                
                                if (productsToAdd && productsToAdd[0] && productsToAdd[0].variantID === cartItem.variant_id) {
                                  console.log("Este producto no es valido para contar")
                                } else {
                                  const isFromPromo = productsIf.find(prod => prod.variantID === cartItem.variant_id)
                                  if (isFromPromo) {
                                    pusher.push(cartItem)
                                    totalQty = totalQty + cartItem.quantity
                                  }
          
                                }
                            }
                            console.log("Cuantos agregados:", totalQty, " cuandos debe tener:", promoDataObj.numberCollection )

                            if (totalQty >= promoDataObj.numberCollection) {
                                hasPromo = true
                            } else {
                                hasPromo = false
                            }
                        }

                        if (hasPromo) {
                            let list = []

                            productsToAdd.forEach(prod => {
                                if (!variantsIdCurrentCart.includes(prod.variantID)) {

                                    if (productsToAdd.length === 1) {
                                        list = [{
                                            id: prod.variantID,
                                            quantity: 1,
                                            properties: {
                                                "itsFree": "true"
                                            }
                                        }]
                                    } else {
                                        list.push({
                                            id: prod.variantID,
                                            quantity: 1,
                                            properties: {
                                                "itsFree": "true"
                                            }
                                        })
                                    }
                                
                                }
                            })

                            if (list[0]) {
                                const isadded = $Cart.state.info.items.find((item) => (item.properties.itsFree))
                                console.log("Item con free:", isadded)
                                $Cart.addItem(list, false)
                            }

                        } else {
                            let needReload = false;
                            productsToAdd.forEach(prod => {
                                const removerItem = $Cart.state.info.items.find((item) => (item.variant_id === prod.variantID && item.properties.itsFree))
                                if (removerItem) {
                                    $Cart.removeItem(removerItem.id)
                                    if(window.location.href.includes('/cart') && !needReload) {
                                        needReload = true;
                                    }
                                }
                            })
                            if(needReload) {
                                $Cart.get().then(e => {
                                    window.location.reload();
                                });
                            }
                        }


                        currentCart.items.forEach(cartItem => {

                            if (promoDataObj.numberCollection === 0) {
                                if (cartItem.price == 0 && variantsIdCurrentCart.includes(cartItem.variant_id) && !variantsIdProductsToAdd.includes(cartItem.variant_id)) {
                                    $Cart.removeItem(cartItem.variant_id)
                                }
                            } else {

                            }

                        })
                    }

                    if (promo && promo.type == 'gift_discount_by_total_amount') {
                        let currentAmount = currentCart.total_price / 100

                        if (currentAmount >= promoDataObj.minTotal) {
                            const productsToAdd = data['ifAddThis']
                            let variantsIdCurrentCart = currentCart.items.map(a => a.variant_id)

                            let addProduct = true
                            for (let i = 0; i < currentCart.items.length; i++) {
                                const cartItem = currentCart.items[i]
                                if (
                                    cartItem.properties?.hasDiscount ||
                                    cartItem.properties?.discount
                                ) {
                                    addProduct = false
                                }
                            }

                            if (addProduct) {
                                const list = []
                                productsToAdd.forEach(prod => {
                                    if (!variantsIdCurrentCart.includes(prod.variantID)) {
                                        list.push({
                                            id: prod.variantID,
                                            quantity: 1,
                                            properties: {
                                                "hasDiscount": "true",
                                                "discount": promoDataObj.minTotalAmount
                                            }
                                        })
                                    }
                                })
                                if (list[0]) $Cart.addItem(list, false)
                            }

                        } else {
                            console.log("La promo NO es valida...")
                            let removeProduct = false
                            for (let i = 0; i < currentCart.items.length; i++) {
                                const cartItem = currentCart.items[i]
                                if (
                                    cartItem.properties?.hasDiscount ||
                                    cartItem.properties?.discount
                                ) {
                                    removeProduct = cartItem.variant_id
                                }
                            }
                            if (removeProduct) {
                                $Cart.removeItem(removeProduct)
                            }

                        }

                    }

                    if (promo && promo.type == 'gift_discount_by_quantity_items') {

                        let currentAmount = currentCart.item_count

                        if (data && data.productTypeLimit && data.productTypeLimit != '') {
                            currentAmount = 0
                            for (let i = 0; i < currentCart.items.length; i++) {
                                const item = currentCart.items[i]
                                if (
                                    (data.productTypeLimit.includes(item.product_type)) && (!item.properties.itsFree || !item.properties.hasDiscount)
                                ) {
                                    currentAmount = currentAmount+item.quantity
                                }
                            }
                        }

                        if (currentAmount >= promoDataObj.minTotal) {
                            const productsToAdd = data['ifAddThis']
                            let variantsIdCurrentCart = currentCart.items.map(a => a.variant_id)

                            console.log("Add this:", productsToAdd)

                            let addProduct = true
                            for (let i = 0; i < currentCart.items.length; i++) {
                                const cartItem = currentCart.items[i]
                                if (
                                    cartItem.properties?.hasDiscount ||
                                    cartItem.properties?.discount || 
                                    cartItem.properties?.itsFree
                                ) {
                                    addProduct = false
                                }
                            }

                            if (addProduct) {
                                const list = []
                                productsToAdd.forEach(prod => {
                                    if (!variantsIdCurrentCart.includes(prod.variantID)) {
                                        list.push({
                                            id: prod.variantID,
                                            quantity: 1,
                                            properties: {
                                                "hasDiscount": "true",
                                                "discount": promoDataObj.minTotalAmount
                                            }
                                        })
                                    }
                                })
                                if (list[0]) $Cart.addItem(list, false)
                            }

                        } else {
                            console.log("La promo by qty NO es valida...")
                            let removeProduct = false
                            for (let i = 0; i < currentCart.items.length; i++) {
                                const cartItem = currentCart.items[i]
                                if (
                                    cartItem.properties?.hasDiscount ||
                                    cartItem.properties?.discount
                                ) {
                                    removeProduct = cartItem.variant_id
                                }
                            }
                            if (removeProduct) {
                                $Cart.removeItem(removeProduct)
                            }

                        }

                    }

                }
            }
        })

    }

}

const promos = new ShopiPromos(Shopify.shop)
setInterval( async () => {
    promos.getPromos()
}, 1500 )

document.addEventListener('CART::UPDATED', () => {

    
})
